import { SyntheticEvent } from "react";
import { Tab, Tabs } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MADERA_BACKOFFICE_PATHS } from "constants/constants";
import { useStyles } from "./MBOSecondaryNav.styles";

const setupDashboardPath = `/${MADERA_BACKOFFICE_PATHS.ROOT_PATH}/${MADERA_BACKOFFICE_PATHS.SETUP_DASHBOARD.ROOT}`;
const apiAccessPath = `/${MADERA_BACKOFFICE_PATHS.ROOT_PATH}/${MADERA_BACKOFFICE_PATHS.API_ACCESS}`;

enum MBOTab {
    corporations = "corporations",
    apiAccess = "api_access",
}

/**
 * Secondary navigation for the MBO back-office, rendered beneath the MBONavbar.
 * Mirrors the corporate back-office tab style (pages/Corporate/Locations). Active tab
 * is derived from the current path so it stays in sync on direct navigation/back.
 */
export const MBOSecondaryNav = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const selectedTab = pathname.includes(`/${MADERA_BACKOFFICE_PATHS.API_ACCESS}`)
        ? MBOTab.apiAccess
        : MBOTab.corporations;

    const handleTabChange = (_: SyntheticEvent, newValue: MBOTab) => {
        navigate(newValue === MBOTab.apiAccess ? apiAccessPath : setupDashboardPath);
    };

    return (
        <div className={classes.wrapper}>
            <div className={classes.container}>
                <Tabs className={classes.tabs} value={selectedTab} onChange={handleTabChange}>
                    <Tab value={MBOTab.corporations} label={t("api_access.nav.corporations")} />
                    <Tab value={MBOTab.apiAccess} label={t("api_access.nav.api_access")} />
                </Tabs>
            </div>
        </div>
    );
};
